exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-page[data-v-e9c0077e]{padding-top:1rem;height:100%;min-height:100vh;position:relative}.menu-thumbnail[data-v-e9c0077e]{max-height:5rem;min-height:5rem;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e9c0077e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SpotlightManage.vue
// module id = 430
// module chunks = 0